<div class="login-box">
  <div class="login-logo">
    <img height="60" src="{{logoPath}}" />
  </div>
  <div class="login-box-body">
    <form [formGroup]="login">
      <div
        class="has-feedback"
        [class.has-error]="username.invalid && username.dirty"
      >
        <input
          type="text"
          class="form-control"
          placeholder="Usuário"
          formControlName="username"
        />
      </div>
      <div
        *ngIf="!isPasswordForgot()"
        class="has-feedback mt-2"
        [class.has-error]="oldPassword.invalid && oldPassword.dirty"
      >
        <input
          type="password"
          class="form-control"
          placeholder="Senha Atual"
          formControlName="oldPassword"
        />
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        <div
          class="help-block"
          [hidden]="!oldPassword.hasError('required') || oldPassword.pristine"
        >
          Senha inválida
        </div>
        <div
          class="help-block"
          [hidden]="!oldPassword.hasError('minlength') || oldPassword.pristine"
        >
          A senha precisa ter no mínimo 8 caracteres
        </div>
      </div>
      <div
        class="has-feedback mt-2"
        [class.has-error]="newPassword.invalid && newPassword.dirty"
      >
        <input
          type="password"
          class="form-control"
          placeholder="Nova Senha"
          formControlName="newPassword"
        />
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        <div
          class="help-block"
          [hidden]="!newPassword.hasError('required') || newPassword.pristine"
        >
          Senha inválida
        </div>
        <div
          class="help-block"
          [hidden]="!newPassword.hasError('minlength') || newPassword.pristine"
        >
          A senha precisa ter no mínimo 8 caracteres
        </div>
        <div
          class="help-block"
          [hidden]="
            !newPassword.hasError('passwordComplexity') || newPassword.pristine
          "
        >
          A senha precisa atender ao menos 3 das seguintes regras:
          <ul>
            <li>Caracteres maiúsculos (A, B, C...)</li>
            <li>Caracteres minúsculos (a, b, c...)</li>
            <li>Numerais (0, 1, 2, 3, 4, 5, 6, 7, 8, 9)</li>
            <li>Caracteres especiais (@ # &)</li>
          </ul>
        </div>
      </div>
      <div
        class="has-feedback mt-2"
        [class.has-error]="
          newPasswordConfirmation.invalid && newPasswordConfirmation.dirty
        "
      >
        <input
          type="password"
          class="form-control"
          placeholder="Confirmar Nova Senha"
          formControlName="newPasswordConfirmation"
        />
        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
        <div
          class="help-block"
          [hidden]="
            !newPasswordConfirmation.hasError('required') ||
            newPasswordConfirmation.pristine
          "
        >
          Senha inválida
        </div>
        <div
          class="help-block"
          [hidden]="
            !newPasswordConfirmation.hasError('minlength') ||
            newPasswordConfirmation.pristine
          "
        >
          A senha precisa ter no mínimo 8 caracteres
        </div>
        <div
          class="help-block"
          [hidden]="
            !newPasswordConfirmation.hasError('newPasswordConfirmation') ||
            newPasswordConfirmation.pristine
          "
        >
          A confirmação de senha deve ser igual à nova senha
        </div>
      </div>
      <button
        class="btn btn-primary btn-block btn-flat mt-2"
        (click)="resetPassword()"
        [disabled]="isAuthenticating"
      >
        Entrar
      </button>
      <br />
      <!-- <a href="/esqueci-minha-senha">Esqueci minha senha</a> -->
    </form>
  </div>
</div>
